document.addEventListener("DOMContentLoaded", function () {
    let productHandle = "{{ product.handle }}"; 

    if (productHandle && window.location.pathname.includes('/products/')) {
        let viewedProducts = JSON.parse(localStorage.getItem("recentlyViewed")) || [];

        // Remove if already exists
        viewedProducts = viewedProducts.filter(item => item !== productHandle);
        
        // Add to beginning
        viewedProducts.unshift(productHandle);

        // Limit to 5 products
        if (viewedProducts.length > 5) {
            viewedProducts.pop();
        }

        localStorage.setItem("recentlyViewed", JSON.stringify(viewedProducts));
    }
});